import legalImage from "../../img/legal.svg";
import travelImage from "../../img/travel.svg";
import packagesImage from "../../img/containers.svg";
import t from "../../locales/common.json";

<style/styles: any>
  .grid {
    display: grid;
    column-gap: var(--space-4);
    justify-content: space-between;
  }

  .card {
    display: grid;
  }

  .image {
    order: -1;
  }

  @media (30rem <=width <=74rem) {
    .card {
      grid-template-columns: auto 1fr;
      column-gap: var(--space-4);
    }

    .image {
      grid-row: span 2;
    }
  }

  @media (width > 74rem) {
    .grid {
      grid-template-columns: repeat(3, 22rem);
    }

    .card {
      grid-template-rows: subgrid;
      grid-row: span 3;
    }

    .image {
      margin-block-end: var(--space-2);
    }
  }
</style>

static const services = [
  {
    key: "legal",
    title: t.cc.HomePage.legal.header,
    image: legalImage,
    text: t.cc.HomePage.legal.description,
  },
  {
    key: "travel",
    title: t.cc.HomePage.travel.header,
    image: travelImage,
    text: t.cc.HomePage.travel.description,
  },
  {
    key: "packages",
    title: t.cc.HomePage.packages.header,
    image: packagesImage,
    text: t.cc.HomePage.packages.description,
  },
];

<section-region>
  <div class=["wrapper", styles.grid]>
    <for|service| of=services>
      <article class=[styles.card]>
        <heading-2 class="text1 font-semibold mbe-3 align-self-end">
          ${service.title}
        </heading-2>
        <div class=["flex justify-content-center", styles.image]>
          <img
            style={ width: "200px", height: "200px" }
            width="200"
            height="200"
            alt=service.title
            src=service.image
          >
        </div>
        <span>${service.text}</span>
      </article>
    </for>
  </div>
</section-region>
